/**
 * The only place the browser leaves for the payment provider (#3017).
 *
 * `checkoutUrl` comes from our own API, but a navigation to an attacker-chosen
 * address is too costly a bug to leave to trust: only an https Stripe Checkout
 * host without credentials or a custom port is followed. A hosted custom
 * checkout domain, if OceanSpace ever configures one, is added here on purpose.
 *
 * Mirrors `isSafeStripeCheckoutUrl` in `@vehiclespace/shared`
 * (packages/shared/src/utils/stripe-checkout-url.ts), which staff-api applies
 * to the URL Stripe returns: the server never hands out a URL refused here.
 * Change both together.
 */

const CHECKOUT_HOSTS: ReadonlySet<string> = new Set(['checkout.stripe.com']);

export function isSafeCheckoutUrl(raw: string): boolean {
  let url: URL;
  try {
    url = new URL(raw);
  } catch {
    return false;
  }
  return (
    url.protocol === 'https:' &&
    CHECKOUT_HOSTS.has(url.hostname) &&
    url.port === '' &&
    url.username === '' &&
    url.password === ''
  );
}

/** Navigates to Stripe. Returns `false`, without navigating, for an unsafe URL. */
export function redirectToCheckout(raw: string): boolean {
  if (!isSafeCheckoutUrl(raw)) return false;
  window.location.assign(raw);
  return true;
}
